var map = {
	"./alert-circle.png": 79588,
	"./check-circle.png": 97990,
	"./icon-videmao-download.webp": 66852,
	"./image-free-download-video.webp": 70659,
	"./image-how-to-use-short-domain.webp": 22568,
	"./image-paste-youtube-url.webp": 17639,
	"./image-select-file.webp": 85837,
	"./image-viemao-download-bottom.webp": 15654,
	"./logo-viemao-title.webp": 95022,
	"./x-circle.png": 63822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;